
// src/components/index.js
import { Buffer } from 'buffer';
window.Buffer = Buffer;

export { default as Loader } from "./Loader";
export { default as Navbar } from "./Navbar";
export { default as Welcome } from "./Welcome";
export { default as Footer } from "./Footer";
export { default as Services } from "./Services";
export { default as Transactions } from "./Transactions";
export { default as NFTForm } from "./NFTForm";
export { default as VideoComponent } from "./VideoComponent";
export { default as FlatSurfaceDetector } from "./FlatSurfaceDetector";
export { default as HardwareDepthBadge } from "./HardwareDepthBadge";
